const STORAGE_UUID_PREFIX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;

export function getFileNameFromStorageUrl(url: string, fallback = "archivo"): string {
  try {
    const pathname = new URL(url).pathname;
    const segment = pathname.split("/").filter(Boolean).pop();
    if (!segment) return fallback;
    const decoded = decodeURIComponent(segment);
    const withoutUuid = decoded.replace(STORAGE_UUID_PREFIX, "");
    return withoutUuid || decoded || fallback;
  } catch {
    return fallback;
  }
}
